import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import VSelect from 'vue-select';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'SortSelector',
  props: {
    value: null,
    options: null
  },
  emits: ['onSelect'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var safeValue = computed(function () {
      return props.options.find(function (option) {
        return option.id === props.value;
      }) || props.options[0].id;
    });
    function onSelect(selected) {
      emit('onSelect', selected);
    }
    return {
      __sfc: true,
      props: props,
      emit: emit,
      safeValue: safeValue,
      onSelect: onSelect,
      VSelect: VSelect,
      AzIcon: AzIcon
    };
  }
});